import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { ThemeProvider as ThemeProvider$1 } from 'styled-components';

const ThemeProvider = (_a) => {
    var { theme } = _a, props = __rest(_a, ["theme"]);
    return React.createElement(ThemeProvider$1, Object.assign({ theme: { olist: theme } }, props));
};

export { ThemeProvider as default };
